import React from 'react';
import LazyLoad from '../LazyLoad/LazyLoad';
import styles from './InteractiveJobMap.module.css';
import TextSectionMarkdown from '../TextSectionMarkdown/TextSectionMarkdown';
import { ComponentContainerProps } from 'types/Shared/ComponentContainer';
import { extractColors } from '@utils/utils';

type Props = ComponentContainerProps;

export default function InteractiveJobMap({ section }: Props): JSX.Element {
  return (
    <section
      className={styles['interactive-job-map']}
      style={{ backgroundColor: extractColors(section.backgroundColor) }}
    >
      <TextSectionMarkdown
        markdown={section.sectionHeader}
        textColor={section.headerTextColor}
        backgroundColor={section.backgroundColor}
      />
      <LazyLoad>
        <iframe
          src="https://www.careerarc.com/job-map/clayton-homes/campaign/37737"
          title="Clayton Homes Career Arc"
          allow="geolocation"
          frameBorder="0"
          width="100%"
          height="600px"
          style={{
            width: '100%',
            height: '600px',
            border: '0',
          }}
        ></iframe>
      </LazyLoad>
    </section>
  );
}
